module.exports = __webpack_public_path__ + "media/images/flags/64/Peru-46dc4cf55b54b589489e88a0ed756cff.png";